<div class="sizer-wrap">
    <div class="strip"></div>
    <div class="sizer">
        <div class="line">

        </div>
    </div>
    <button class="btn">
        <div class="overlay"></div>
        <span class="cursor-pointer fill-current text-white flex-shrink-0 leading-none">
            <svg-icon [name]="icon"
                      [size]="24"
                      class="icon text-textMedium">
            </svg-icon>
        </span>
    </button>
</div>